(function () {
  'use strict';

  var GRID_SELECTOR = '#halo-product-block-product_tab_block_GGGDMw .products-grid';

  function forceTopAlignment(grid) {
    if (!grid) return;

    grid.style.setProperty('display', 'grid', 'important');
    grid.style.setProperty('align-items', 'start', 'important');
    grid.style.setProperty('align-content', 'start', 'important');

    Array.prototype.forEach.call(grid.children, function (product) {
      if (!product.classList || !product.classList.contains('product')) return;

      product.classList.add('lc-grid-normalized');
      product.style.setProperty('position', 'relative', 'important');
      product.style.setProperty('top', '0', 'important');
      product.style.setProperty('margin-top', '0', 'important');
      product.style.setProperty('transform', 'none', 'important');
      product.style.setProperty('translate', '0 0', 'important');
      product.style.setProperty('opacity', '1', 'important');
      product.style.setProperty('align-self', 'start', 'important');
      product.style.setProperty('vertical-align', 'top', 'important');
      product.style.setProperty('animation', 'none', 'important');
      product.removeAttribute('data-cascade');

      product.querySelectorAll('.product-item, .card, .scroll-trigger, .animate--slide-in').forEach(function (node) {
        node.style.setProperty('position', 'relative', 'important');
        node.style.setProperty('top', '0', 'important');
        node.style.setProperty('margin-top', '0', 'important');
        node.style.setProperty('transform', 'none', 'important');
        node.style.setProperty('translate', '0 0', 'important');
        node.style.setProperty('opacity', '1', 'important');
        node.style.setProperty('animation', 'none', 'important');
        node.style.setProperty('animation-delay', '0s', 'important');
        node.removeAttribute('data-cascade');
      });
    });
  }

  function normalizeAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(forceTopAlignment);
  }

  function observeGrid(grid) {
    if (!grid || grid.dataset.lcAlignmentObserver === 'true') return;
    grid.dataset.lcAlignmentObserver = 'true';

    var observer = new MutationObserver(function (mutations) {
      var hasNewProducts = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.addedNodes.length > 0;
      });

      if (!hasNewProducts) return;

      forceTopAlignment(grid);
      window.requestAnimationFrame(function () { forceTopAlignment(grid); });
      window.setTimeout(function () { forceTopAlignment(grid); }, 80);
      window.setTimeout(function () { forceTopAlignment(grid); }, 350);
    });

    observer.observe(grid, { childList: true });
    forceTopAlignment(grid);
  }

  function init() {
    document.querySelectorAll(GRID_SELECTOR).forEach(observeGrid);
    normalizeAll();

    /* Product tabs may rebuild their grids after intersection/AJAX loading. */
    var section = document.getElementById('halo-product-block-product_tab_block_GGGDMw');
    if (section && section.dataset.lcSectionObserver !== 'true') {
      section.dataset.lcSectionObserver = 'true';
      new MutationObserver(function () {
        document.querySelectorAll(GRID_SELECTOR).forEach(observeGrid);
        normalizeAll();
      }).observe(section, { childList: true, subtree: true });
    }

    /* Extra delayed passes cover theme scripts that apply layout after AJAX completion. */
    [100, 400, 900, 1600].forEach(function (delay) {
      window.setTimeout(normalizeAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* LC V12: local tab switching for the static Best Sellers section. */
(function () {
  'use strict';

  function initStaticTabs(root) {
    if (!root || root.dataset.lcStaticTabsReady === 'true') return;
    root.dataset.lcStaticTabsReady = 'true';

    var buttons = root.querySelectorAll('[data-product-tabtop], [data-product-tabTop]');
    var panels = root.querySelectorAll('[data-product-tabcontent], [data-product-TabContent]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var targetSelector = button.getAttribute('data-target');
        if (!targetSelector) return;

        buttons.forEach(function (item) { item.classList.remove('active'); });
        panels.forEach(function (panel) { panel.classList.remove('active'); });
        button.classList.add('active');

        var target = root.querySelector(targetSelector);
        if (target) target.classList.add('active');

        var dropdownLabel = root.querySelector('.label-active .tab-links');
        if (dropdownLabel) dropdownLabel.textContent = button.textContent.trim();
      });
    });
  }

  function initAllStaticTabs() {
    document.querySelectorAll('[data-lc-static-product-tabs]').forEach(initStaticTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStaticTabs, { once: true });
  } else {
    initAllStaticTabs();
  }
  document.addEventListener('shopify:section:load', initAllStaticTabs);
})();

/* LC V15.1: keep headers configured as "always" sticky visible.
   This intentionally avoids modifying the theme's inline header JavaScript. */
(function () {
  'use strict';

  var scheduled = false;

  function stabilizeHeader() {
    scheduled = false;

    var desktopSticky = document.querySelector('sticky-header[data-sticky-type="always"]');
    if (desktopSticky) {
      var desktopSection = desktopSticky.closest('.section-header-navigation');
      if (desktopSection) {
        desktopSection.classList.add('lc-sticky-always-visible', 'shopify-section-header-sticky');
        desktopSection.classList.remove('shopify-section-header-hidden');
      }
    }

    var mobileSticky = document.querySelector('sticky-header-mobile[data-sticky-type="always"], sticky-header-mobile[data-sticky-type="reduce-logo-size"]');
    if (mobileSticky) {
      var mobileSection = mobileSticky.closest('.section-header-mobile');
      if (mobileSection) {
        mobileSection.classList.add('lc-sticky-always-visible', 'shopify-section-header-sticky');
        mobileSection.classList.remove('shopify-section-header-hidden');
      }
    }

    if (desktopSticky || mobileSticky) {
      document.body.classList.remove('section-header-is-hidden');
    }
  }

  function scheduleStabilize() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(stabilizeHeader);
  }

  function initStableHeader() {
    stabilizeHeader();
    window.setTimeout(stabilizeHeader, 150);
    window.setTimeout(stabilizeHeader, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStableHeader, { once: true });
  } else {
    initStableHeader();
  }

  window.addEventListener('load', initStableHeader, { once: true });
  window.addEventListener('pageshow', initStableHeader);
  window.addEventListener('scroll', scheduleStabilize, { passive: true });
  window.addEventListener('resize', scheduleStabilize, { passive: true });
  document.addEventListener('shopify:section:load', initStableHeader);
})();

/* LC V15.2: prevent the mobile Sort modal from being activated on tablet/desktop widths. */
(function () {
  'use strict';

  function clearDesktopSortModalState() {
    if (window.innerWidth < 768) return;

    document.body.classList.remove('toolbar-modal-open');
    document.querySelectorAll('.lc-collection-toolbar [data-toggle][data-mobile="mobile"]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    if (window.innerWidth < 768) return;

    var mobileToggle = event.target.closest('.lc-collection-toolbar [data-toggle][data-mobile="mobile"]');
    if (!mobileToggle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    clearDesktopSortModalState();

    var toolbar = mobileToggle.closest('.lc-collection-toolbar');
    var desktopToggle = toolbar && toolbar.querySelector('.filter-sortby .label-tab.hidden-on-mobile[data-toggle="dropdown"]');
    if (desktopToggle) desktopToggle.click();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearDesktopSortModalState, { once: true });
  } else {
    clearDesktopSortModalState();
  }

  window.addEventListener('load', clearDesktopSortModalState, { once: true });
  window.addEventListener('resize', clearDesktopSortModalState, { passive: true });
  window.addEventListener('pageshow', clearDesktopSortModalState);
  document.addEventListener('shopify:section:load', clearDesktopSortModalState);
})();
